import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function postToken() {
  return $apiClient.post(`${ApiConfig.REFRESH}`);
}
